"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};
const getSnapshot = () => window.location.hostname;
const getServerSnapshot = () => "";

/** The hostname serving this page — empty until hydration, since only the client knows it. */
export function useAppHost(): string {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
